<template>
  <div class="common-list">
    <selector select="selector-order" @handleTicketOrder="handleTicketOrder"></selector>
    <orderTypes v-if="orderTypeList.length > 1" :orderTypeList="orderTypeList"></orderTypes>
    <router-view v-if="orderTypeList.length > 0"></router-view>
    <emptyContent text="您没有历史订单记录" v-else></emptyContent>
  </div>
</template>

<script>
import selector from "@/components/entry/buyTicketHome/selector";
import orderTypes from "@/components/order/orderlist/types";
import { getEffective, getGroupOrder, getFreeTicketOrder } from '@/service/order/orderlist.js';

export default {
  name: "orderlist",
  data(){
    return {
      userInfo: {},
      perPageSize: 5,
      pageNo: 1,
      orderTypeList: [],
    }
  },
  created(){
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'));
    console.log('订单列表------')
    console.log(this.userInfo)
    this.generateOrderOption();
  },
  methods: {
    async generateOrderOption(){
      const parameter = {
        userId: this.userInfo.userId,
        perPageSize: this.perPageSize,
        pageNo: this.pageNo,
        deleteFlag: '0',
      };
      const orderTypeList = [];
      const requestList = [getEffective.call(this, parameter), getFreeTicketOrder.call(this, parameter)];
      const checkGuideState = this.$checkGuideState();
      if(checkGuideState)requestList.push(getGroupOrder.call(this, parameter));
      const result = await Promise.all(requestList);
      result.forEach((item, index) => result[index] = item.data);
      this.$store.commit('setOrderListPool', {
        data: result[0],
        key: 'individualOrder'
      });
      this.$store.commit('setOrderListPool', {
        data: result[1],
        key: 'freeTicketOrder'
      });
      if(checkGuideState){
        this.$store.commit('setOrderListPool', {
          data: result[2],
          key: 'groupOrder'
        });
      };
      const individualOrderTotalCount = Number(result[0].totalCount);
      const freeTicketOrderTotalCount = Number(result[1].totalCount);
      const groupOrderTotalCount = result[2] ? Number(result[2].totalCount) : 0;
      const available = [individualOrderTotalCount, groupOrderTotalCount, freeTicketOrderTotalCount].findIndex(item => item > 0);
      const ordertype = Number(this.$route.params.ordertype);
      if(ordertype === 0 && individualOrderTotalCount == 0){
        if(available === 1){
          this.$router.push('/orderlist/1');
        }else if(available === 2){
          this.$router.push('/orderlist/2');
        }
      }else if(ordertype === 1 && groupOrderTotalCount == 0){
        if(available === 0){
          this.$router.push('/orderlist/0');
        }else if(available === 2){
          this.$router.push('/orderlist/2');
        }
      }else if(ordertype === 2 && freeTicketOrderTotalCount == 0){
        if(available === 0){
          this.$router.push('/orderlist/0');
        }else if(available === 1){
          this.$router.push('/orderlist/1');
        }
      };
      if(individualOrderTotalCount > 0){
        orderTypeList.push({
          name: '散客',
          path: '/orderlist/0'
        })
      };
      if(groupOrderTotalCount > 0){
        orderTypeList.push({
          name: '团体',
          path: '/orderlist/1'
        })
      };
      if(freeTicketOrderTotalCount > 0){
        orderTypeList.push({
          name: '免费',
          path: '/orderlist/2',
        })
      };
      // console.log('订单表头----')
      // console.log(orderTypeList)
      this.orderTypeList = orderTypeList;
    },
    handleTicketOrder(){
      this.$router.push('/buytickethome/0/0');
    },
  },
  components: {
    orderTypes,
    selector,
  },
  beforeDestroy(){
    this.$store.commit('setOrderListPool', { data: {}, key: 'individualOrder' });
    this.$store.commit('setOrderListPool', { data: {}, key: 'freeTicketOrder' });
    this.$store.commit('setOrderListPool', { data: {}, key: 'groupOrder' });
  }
};
</script>
